/**
 * The whole public frontend lives under the internal `/t/[tenant]` segment.
 * The proxy rewrites every public host to that segment, so during prerendering
 * and SSR `usePathname()` returns `/t/<tenant>/...` while the browser URL (and
 * the client router after hydration) is the public path without the prefix.
 * Normalizing to the public path keeps server and client output identical.
 */
const TENANT_SEGMENT_PATTERN = /^\/t\/[^/]+(?=\/|$)/;

export const toPublicPathname = (
  pathname: string | null | undefined
): string => {
  if (!pathname) {
    return "/";
  }

  const stripped = pathname.replace(TENANT_SEGMENT_PATTERN, "");
  return stripped === "" ? "/" : stripped;
};
